import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import { translate } from "../../utils/utils";
import { useMediaQuery } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import moment from "moment";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Item = styled(Paper)(({ theme }) => ({
  border: "1px solid #C2C2C2",
  borderRadius: "10px",
  padding: theme.spacing(1),
  textAlign: "center",
  height: "65px",
  maxWidth: "200px",
}));

export default function AssetDetails({
  open,
  handleClose,
  disabled,
  id,
  data,
  handleOpen,
  handleUpdate,
  id_owner,
  company,
  show,
}) {
  const { t } = useTranslation();
  const [rowDetails, setRowDetails] = useState({});

  useEffect(() => {
    if (id) {
      setRowDetails(data.filter((el) => el?.id === id)[0]);
    }
  }, [data, id, show]);
  const isMobile = useMediaQuery("(max-width:1400px)");

  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        maxWidth="xl"
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          sx: !isMobile
            ? { width: "35%", padding: "20px " }
            : {
                width: "90%",
                height: "70%",
                margin: "5px 0",
                padding: "5px ",
                backgroundColor: "#F3F9F8",
                "& 	.MuiBackdrop-root": { backgroundColor: "white" },
              },
        }}
      >
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <IconButton onClick={handleClose}>
            <CloseIcon sx={{ width: "70%", color: "black" }} />
          </IconButton>
        </div>
        <DialogTitle>
          <Grid container>
            <Grid item xs={12}>
              <Typography
                variant="accordion1"
                sx={{ fontSize: "25px", lineHeight: "43.2px" }}
              >
                {rowDetails?.[translate("title")] || t("not_specified")}
              </Typography>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent sx={{ marginTop: "5px" }}>
          <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={4} align="center">
              <Item
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "80%",
                  p: 0,
                  mb: "5px",
                }}
              >
                <Typography
                  sx={{
                    color: "#00000080",
                    mt: 1,
                    fontSize: "12px",
                    fontHeight: "19.5",
                    p: 0,
                  }}
                >
                  {t("value")}
                </Typography>
                <Typography
                  variant="title3"
                  sx={{ m: 1, fontSize: "14px", fontHeight: "36px" }}
                >
                  {rowDetails?.value}
                </Typography>
              </Item>
            </Grid>
            <Grid item xs={4} align="center">
              <Item
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  flexWrap: "wrap",
                  p: 0,
                }}
              >
                <Typography
                  sx={{
                    color: "#00000080",
                    mt: 1,
                    fontSize: "12px",
                    fontHeight: "19.5",
                  }}
                >
                  Source
                </Typography>
                <Typography
                  variant="title3"
                  sx={{
                    mt: 1,
                    fontSize: "12px",
                    fontHeight: "20px",
                    width: "100%",
                  }}
                >
                  {rowDetails?.source}
                </Typography>
              </Item>
            </Grid>
            <Grid item xs={4} align="center">
              <Item
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  p: 0,
                }}
              >
                <Typography
                  sx={{
                    color: "#00000080",
                    mt: 1,
                    fontSize: "12px",
                    fontHeight: "19.5",
                  }}
                >
                  Date
                </Typography>
                <Typography
                  variant="title3"
                  sx={{ m: 1, fontSize: "10px", fontHeight: "15px" }}
                >
                  {moment(rowDetails?.last_update).format("DD-MM-YYYY")}
                </Typography>
              </Item>
            </Grid>
          </Grid>
          <Typography
            variant="title3"
            sx={{ fontSize: "15px", color: "#b7b7b7db" }}
          >
            {rowDetails?.owner ? t("owner") : ""}
          </Typography>
          <br />
          <Typography sx={{ fontSize: "13px", fontWeight: "800" }}>
            {t(rowDetails?.owner)}
          </Typography>
          <Typography
            variant="title3"
            sx={{ fontSize: "15px", color: "#b7b7b7db" }}
          >
            Description
          </Typography>
          <br />

          <Typography sx={{ fontSize: "13px", fontWeight: "800" }}>
            {rowDetails?.[translate("description")] || t("not_specified")}
          </Typography>
        </DialogContent>
      </Dialog>
    </div>
  );
}
